import * as React from 'react';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';
import { GALRecipientWellModalFromViewstate } from 'owa-global-address-list-recipient-well-modal';
import { RecipientWellLabel } from './RecipientWellLabel';

export const RecipientWellLabelWithGALModal = (props: {
    viewState: RecipientWellWithFindControlViewState;
    recipientType: RecipientType;
}) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const closeModal = React.useCallback(() => {
        setIsModalOpen(false);
    }, [setIsModalOpen]);
    const openModal = React.useCallback(() => {
        setIsModalOpen(true);
    }, [setIsModalOpen]);

    return (
        <>
            <RecipientWellLabel onClick={openModal} recipientType={props.recipientType} />
            {isModalOpen && (
                <GALRecipientWellModalFromViewstate
                    viewState={props.viewState}
                    onDismiss={closeModal}
                    wellLabel={<RecipientWellLabel recipientType={props.recipientType} />}
                />
            )}
        </>
    );
};
